<template>
  <v-layout>
    <SelectFile
      :disabled="disabled"
      @upload="add"
    />
    <v-dialog
      v-model="itemsDialog"
      persistent
      width="1100"
    >
      <v-card>
        <v-card-text>
          <h2>Добавить импортированные товары в Информацию о товаре</h2>
          <div class="v-data-table--fixed-header">
            <v-data-table
              :headers="headers"
              :items="items"
              hide-actions
              :style="{ height: blockHeight, overflow: 'auto' }"
            >
              <template v-slot:headers="props">
                <tr>
                  <th
                    v-for="header in props.headers"
                    :key="header.title"
                  >
                    {{ header.title }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <ImportItemRow
                  :item="props.item"
                  :index="props.index"
                />
              </template>
            </v-data-table>
          </div>
        </v-card-text>
        <v-card-actions v-if="fullItems.length > 0">
          <v-btn
            small
            color="primary"
            :disabled="!items.length"
            :loading="loading"
            @click="save"
          >
            Сохранить
          </v-btn>
          <v-btn
            small
            @click="itemsDialog = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
        <v-card-actions v-else>
          <v-btn
            small
            color="primary"
            @click="closeItemsDialog"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import SelectFile from "../../../components/SelectFile.vue";
import ImportItemRow from "./ImportItemRow.vue";
import * as goodsDetailsApi from "../../../backend/goodsDetailsApi.js";
import goodsDetailsItemsHeaders from "../components/goods-details-items-headers.js";

export default {
  components: {
    SelectFile,
    ImportItemRow,
  },
  props: ["goodsDetailsId", "disabled"],
  data() {
    return {
      items: [],
      loading: false,
      itemsDialog: false,
      headers: goodsDetailsItemsHeaders,
    };
  },
  computed: {
    fullItems() {
      return this.items.filter(
        i =>
          i.manufacturer &&
          i.trademark &&
          (i.model || i.article) &&
          i.nomenclature &&
          i.material &&
          i.country &&
          i.unit &&
          i.quantity,
      );
    },
    blockHeight() {
      return `${window.innerHeight - 200}px`;
    },
  },
  methods: {
    async add(item) {
      this.loading = true;
      this.items = await goodsDetailsApi.importItems(this.goodsDetailsId, item);
      this.loading = false;

      if (this.items.length > 0) {
        this.itemsDialog = true;
      }
    },
    async save() {
      this.loading = true;
      for (const item of this.fullItems) {
        await this.saveNewItem(item);
        this.showInfo(
          `${item.model ? item.model.title : item.article.title} добавлен`,
        );
      }
      this.items = this.items.filter(item => !this.fullItems.includes(item));
      this.loading = false;
      if (!this.items.length) {
        this.closeItemsDialog();
      }
    },
    async saveNewItem(item) {
      const newItem = {
        articleId: item.article ? item.article.id : null,
        countryId: item.country ? item.country.id : null,
        goodSite: item.goodSite,
        material: item.material,
        modelId: item.model ? item.model.id : null,
        nomenclatureId: item.nomenclature ? item.nomenclature.id : null,
        places: item.places ? item.places : 0,
        quantity: item.quantity ? item.quantity : 0,
        trademarkId: item.trademark ? item.trademark.id : null,
        unitId: item.unit ? item.unit.id : null,
        weightBrutto: item.weightBrutto ? item.weightBrutto : 0,
        weightNetto: item.weightNetto ? item.weightNetto : 0,
        volume: item.volume ? item.volume : 0,
        fragile: item.fragile,
        factoryMarking: item.factoryMarking,
        size: item.size,
        productCategoryId: item.productCategory
          ? item.productCategory.id
          : null,
        notes: item.notes,
        cost: item.cost ? item.cost : 0,
        customsNumber: item.customsNumber ? item.customsNumber : "",
        currency: item.currency ? item.currency : null,
      };
      await goodsDetailsApi.addItem(this.goodsDetailsId, newItem);
    },
    closeItemsDialog() {
      this.$emit("import");
      this.itemsDialog = false;
    },
  },
};
</script>
